import { HistoryDrawer } from '@/features/audit/components/HistoryDrawer'
import { EntityHistoryType, useEntityHistory } from '@/features/audit/hooks'
import { useMinute } from '@/hooks/useMinute'

import { TflFileAuditMessage } from './TflFileAuditMessage'

interface TflFileHistoryDrawerProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  documentId: string
}

export const TflFileHistoryDrawer = ({
  open,
  onOpenChange,
  documentId,
}: TflFileHistoryDrawerProps) => {
  const { data, isLoading, hasNextPage, isFetchingNextPage, fetchNextPage } =
    useEntityHistory(EntityHistoryType.DOCUMENT, documentId, open, {
      log_type: ['TFL_FILE'],
    })

  useMinute()

  const entries = data?.pages.flatMap((page) => page.data || []) || []

  return (
    <HistoryDrawer
      open={open}
      onOpenChange={onOpenChange}
      entries={entries}
      title="History"
      isLoading={isLoading}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      fetchNextPage={fetchNextPage}
      renderDescription={(entry) => <TflFileAuditMessage entry={entry} />}
    />
  )
}
